// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Music_pageName__1pAZN"};